import { AuthContext, ErrorHandling } from "@sagecentral/core-ui";
import { useContext, useEffect, useState } from "react";
import AuthHelperUI from "./AuthHelperUI";

const LoginCallback = () => {
    const auth = useContext(AuthContext);
    const [error, setError] = useState<any | null>(null);
    useEffect(() => {
        if (auth === null) return;
        (async () => {
            try{
                await auth.signinRedirectCallback();
                setError(null);
            }
            catch(e){
                setError(e);
            }
        })();

    }, [ auth ]);

    if(error!==null){
        return (
            <ErrorHandling error={error} />
        );
    }
    return (
        <AuthHelperUI>Login done, loading your request.</AuthHelperUI>
    );
};

export default LoginCallback;
